import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import { IPopularDirectionsBeket } from './model'

export const PopularDirectionsBeket = {
  getPopularDestinations() {
    return clientApi.get<Response<IPopularDirectionsBeket[]>>(
      'bus/popular-destinations',
    )
  },
}
